import { render, staticRenderFns } from "./ChangeChallengeModal.vue?vue&type=template&id=040d6be4&scoped=true&"
import script from "./ChangeChallengeModal.vue?vue&type=script&lang=js&"
export * from "./ChangeChallengeModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeChallengeModal.vue?vue&type=style&index=0&id=040d6be4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040d6be4",
  null
  
)

export default component.exports